// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type='checkbox'] {
  height: 1.5em !important;
  width: 1.2em !important;
  line-height: 0 !important;
}

.table thead tr th,
.table tbody tr td {
  position: relative !important;
  border: 1px solid #b6bac1 !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.table tbody tr td {
  padding: 11px 9px 5px !important;
}
.table td,
.table th {
  position: relative !important;
  border: 1px solid #edf1f7 !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
}
.table td {
  padding: 0.75rem !important;
}
.table th {
  padding: 1rem !important;
  border: 1px solid #255758 !important;
  background: #369 !important;
  color: #fff !important;
}

.table th label,
.table th label > span {
  color: #fff !important;
}
.table thead tr th .form-row .form-group {
  margin-bottom: 0px !important;
}
.table thead tr th {
  padding: 1rem !important;
  border: 1px solid #255758 !important;
  background: #369 !important;
  color: #fff !important;
}

.table thead tr th label {
  color: #fff !important;
}
/* # Phone */
@media only screen and (max-width: 320px) {
  .overflowX {
    overflow-x: scroll !important;
  }
}
/* # Tablet */
@media only screen and (min-width: 321px) and (max-width: 768px) {
  .overflowX {
    overflow-x: scroll !important;
  }
}
/*
Generic Styling, for Desktops/Laptops
*/
table {
  width: 100% !important;
  border-collapse: collapse !important;
}
/* Zebra striping */

/*
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */
  }

  th {
    display: none !important;
  }
  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute !important;
    top: -9999px !important;
    left: -9999px !important;
  }

  tr {
    border: 1px solid #ccc !important;
  }

  td {
    /* Behave  like a "row" */
    border: none !important;
    border-bottom: 1px solid #eee !important;
    position: relative !important;
    padding-left: 50% !important;
  }
  .table tbody tr td {
    text-align: left !important ;
  }

  td:before {
    /* Now like a table header */
    position: absolute; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */
    /* Top/left values mimic padding */
    top: 6px !important;
    left: 0px !important;
    white-space: nowrap !important;
    padding-left: 8px; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */
  }

  /*
	Label the data
	*/
  table td::before {
    content: attr(data-label) !important;
  }
  .mob_padding {
    padding-top: 21px; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */
    text-align: inherit !important;
  }
}

.tableHeaderActions {
  min-height: 30px;
}

.help_header {
  display: flex;
  align-items: center;
}

.help_header i div {
  position: relative;
  white-space: normal;
  margin-bottom: 5px;
  margin-left: 5px;
  line-height: 1.5;
  min-width: 210px;
  max-width: 100%;
  display: inline-block;
  word-break: break-all;
  font-size: 0.75rem;
}

.help_header i div > div {
  display: inline-flex;
  text-align: left;
}

.help_header i div > span:first-child {
  color: #ff3d71;
  min-width: 120px;
  max-width: 120px;
  font-size: 0.7rem;
}

.help_header i div > span:last-child {
  color: #3d98ff;
  font-size: 0.78rem;
}

.moreCol {
  width: 30px;
}

/*
Added by : Jayshree Salve
Data entry grid display in mobile view should appear left-to-right rather than top-to-bottom.
*/
@media only screen and (max-width: 760px) {
  table tbody tr td {
    display: flex;
  }
  td:before {
    position: relative;
    padding-left: 0px;
    width: 50%;
  }
  .mob_padding {
    padding-top: 0px;
    width: 50%;
    text-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/data-entry-grid/data-entry-grid.component.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;AACA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA,YAAY;AACZ;EACE;IACE,6BAA6B;EAC/B;AACF;AACA,aAAa;AACb;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;;CAEC;AACD;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA,mBAAmB;;AAEnB;;;;CAIC;AACD;EACE,8CAA8C;EAC9C;;;;;;IAME,cAAc,EAAE,6GAA6G;EAC/H;;EAEA;IACE,wBAAwB;EAC1B;EACA,mEAAmE;EACnE;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,wCAAwC;IACxC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB,EAAE,6GAA6G;IACjI,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;IAC9B,iBAAiB,EAAE,6GAA6G;EAClI;;EAEA;;EAEA;EACA;IACE,oCAAoC;EACtC;EACA;IACE,iBAAiB,EAAE,6GAA6G;IAChI,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;CAGC;AACD;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["input[type='checkbox'] {\r\n  height: 1.5em !important;\r\n  width: 1.2em !important;\r\n  line-height: 0 !important;\r\n}\r\n\r\n.table thead tr th,\r\n.table tbody tr td {\r\n  position: relative !important;\r\n  border: 1px solid #b6bac1 !important;\r\n  vertical-align: middle !important;\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.table tbody tr td {\r\n  padding: 11px 9px 5px !important;\r\n}\r\n.table td,\r\n.table th {\r\n  position: relative !important;\r\n  border: 1px solid #edf1f7 !important;\r\n  vertical-align: middle !important;\r\n  white-space: nowrap !important;\r\n}\r\n.table td {\r\n  padding: 0.75rem !important;\r\n}\r\n.table th {\r\n  padding: 1rem !important;\r\n  border: 1px solid #255758 !important;\r\n  background: #369 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.table th label,\r\n.table th label > span {\r\n  color: #fff !important;\r\n}\r\n.table thead tr th .form-row .form-group {\r\n  margin-bottom: 0px !important;\r\n}\r\n.table thead tr th {\r\n  padding: 1rem !important;\r\n  border: 1px solid #255758 !important;\r\n  background: #369 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.table thead tr th label {\r\n  color: #fff !important;\r\n}\r\n/* # Phone */\r\n@media only screen and (max-width: 320px) {\r\n  .overflowX {\r\n    overflow-x: scroll !important;\r\n  }\r\n}\r\n/* # Tablet */\r\n@media only screen and (min-width: 321px) and (max-width: 768px) {\r\n  .overflowX {\r\n    overflow-x: scroll !important;\r\n  }\r\n}\r\n/*\r\nGeneric Styling, for Desktops/Laptops\r\n*/\r\ntable {\r\n  width: 100% !important;\r\n  border-collapse: collapse !important;\r\n}\r\n/* Zebra striping */\r\n\r\n/*\r\nMax width before this PARTICULAR table gets nasty\r\nThis query will take effect for any screen smaller than 760px\r\nand also iPads specifically.\r\n*/\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\r\n  /* Force table to not be like tables anymore */\r\n  table,\r\n  thead,\r\n  tbody,\r\n  th,\r\n  td,\r\n  tr {\r\n    display: block; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */\r\n  }\r\n\r\n  th {\r\n    display: none !important;\r\n  }\r\n  /* Hide table headers (but not display: none;, for accessibility) */\r\n  thead tr {\r\n    position: absolute !important;\r\n    top: -9999px !important;\r\n    left: -9999px !important;\r\n  }\r\n\r\n  tr {\r\n    border: 1px solid #ccc !important;\r\n  }\r\n\r\n  td {\r\n    /* Behave  like a \"row\" */\r\n    border: none !important;\r\n    border-bottom: 1px solid #eee !important;\r\n    position: relative !important;\r\n    padding-left: 50% !important;\r\n  }\r\n  .table tbody tr td {\r\n    text-align: left !important ;\r\n  }\r\n\r\n  td:before {\r\n    /* Now like a table header */\r\n    position: absolute; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */\r\n    /* Top/left values mimic padding */\r\n    top: 6px !important;\r\n    left: 0px !important;\r\n    white-space: nowrap !important;\r\n    padding-left: 8px; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */\r\n  }\r\n\r\n  /*\r\n\tLabel the data\r\n\t*/\r\n  table td::before {\r\n    content: attr(data-label) !important;\r\n  }\r\n  .mob_padding {\r\n    padding-top: 21px; /*Removed the !important mark because it was not letting other CSS properties to override them as necessary */\r\n    text-align: inherit !important;\r\n  }\r\n}\r\n\r\n.tableHeaderActions {\r\n  min-height: 30px;\r\n}\r\n\r\n.help_header {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.help_header i div {\r\n  position: relative;\r\n  white-space: normal;\r\n  margin-bottom: 5px;\r\n  margin-left: 5px;\r\n  line-height: 1.5;\r\n  min-width: 210px;\r\n  max-width: 100%;\r\n  display: inline-block;\r\n  word-break: break-all;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.help_header i div > div {\r\n  display: inline-flex;\r\n  text-align: left;\r\n}\r\n\r\n.help_header i div > span:first-child {\r\n  color: #ff3d71;\r\n  min-width: 120px;\r\n  max-width: 120px;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.help_header i div > span:last-child {\r\n  color: #3d98ff;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.moreCol {\r\n  width: 30px;\r\n}\r\n\r\n/*\r\nAdded by : Jayshree Salve\r\nData entry grid display in mobile view should appear left-to-right rather than top-to-bottom.\r\n*/\r\n@media only screen and (max-width: 760px) {\r\n  table tbody tr td {\r\n    display: flex;\r\n  }\r\n  td:before {\r\n    position: relative;\r\n    padding-left: 0px;\r\n    width: 50%;\r\n  }\r\n  .mob_padding {\r\n    padding-top: 0px;\r\n    width: 50%;\r\n    text-wrap: wrap;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
